// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609072304/js/" + chunkId + "." + {"44":"373a38c2","225":"af763b47","481":"b8c2c265","486":"4278add5","770":"887e2118"}[chunkId] + ".0.6626610903189961.chunk.js";
};